import Model from '../models/models.m.js';
import queries from '../queries/checkDocument.q.js';
import tpl from '../templates/checkDocument';
import BaseNewCardView from './../../../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = tpl;

    constructor() {
        super();
        this.state = {
            model: new Model(),
            isSuccess: false,
            isGlobalError: false,
            globalErrorText: '',
            isDisabled: false,
            documentUrl: ''
        };
        this.query = queries;
        this._initMethods();
    }

    shouldFetchData() {
        return false;
    }

    handleChange(event) {
        const data = {
            name: event.target.name,
            value: event.target.value
        };

        this._run(data);
    }

    _run(data) {
        const model = this.getModel();
        model.run({name: data.name, value: data.value});
        this.setState({model});
        this.setState({isGlobalError: false});
    }

    async sendForm(e) {
        e.preventDefault();

        const model = this.getModel();
        const document = model.fields.documentCode.value.replace(/-/g, '');
        await this.query.sendForm(document);
        this.setResult();
    }

    setResult() {
        const isSuccess = this.query.isSuccess;
        const isGlobalError = this.query.isGlobalError;
        const isDisabled = this.query.isDisabled;
        const documentUrl = this.query.documentUrl;
        this.setState({isSuccess, isGlobalError, isDisabled, documentUrl});
        this.state.isGlobalError
            ? this.setState({globalErrorText: 'SERVICE_CHECK_DOCUMENT_ERROR_VALID'})
            : this.setState({globalErrorText: ''});
    }

    backToCheck() {
        this.setState({isSuccess: false});
        const model = this.getModel();
        model.clearValue();
    }

    _initMethods() {
        this.handleChange = this.handleChange.bind(this);
        this.sendForm = this.sendForm.bind(this);
        this.backToCheck = this.backToCheck.bind(this);
    }
}
